var React = require('react');

function Image (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"18","height":"18","rx":"2","ry":"2","key":0}),React.createElement("circle",{"cx":"8.5","cy":"8.5","r":"1.5","key":1}),React.createElement("polyline",{"points":"21 15 16 10 5 21","key":2})]);
}

Image.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-image"};

module.exports = Image;

Image.default = Image;
